import { Error403Unauthorized } from '@app/components';
import { FORBIDDEN_ERROR_MAIN_PART } from '@app/constants';
import { PF } from '@app/pages/Warehouses/ProductCategories/data';
import {
  useProductCategories,
  useProductCategoriesEffects,
} from '@app/pages/Warehouses/ProductCategories/hooks';
import {
  Filters,
  CategoriesTable,
} from '@app/pages/Warehouses/ProductCategories/ui';
import { FiltersAccordion } from '@app/shared/components';

import '@pages/Warehouses/ProductCategories/styles/ProductCategories.scss';

export const ProductCategories = () => {
  const {
    filters,
    unsavedFilters,
    onPaginate,
    range,
    onPageSizeChange,
    columns,
    total,
    tableData,
    onChangeSearchTerm,
    skipSearchTerm,
    onSearch,
    onSearchHandler,
    isPageLoading,
    isFetching,
    IsProductCategories,
  } = useProductCategories();

  useProductCategoriesEffects({ onSearchHandler });

  if (!IsProductCategories) {
    return <Error403Unauthorized title={FORBIDDEN_ERROR_MAIN_PART} />;
  }

  return (
    <div className={`${PF}_container`}>
      <div className={`${PF}_filters-section`}>
        <FiltersAccordion>
          <Filters
            values={filters}
            unsavedValues={unsavedFilters}
            onChangeSearchTerm={onChangeSearchTerm}
            skipSearchTerm={skipSearchTerm}
            onSearch={onSearch}
          />
        </FiltersAccordion>
      </div>

      <div className={`${PF}_table-section`}>
        <CategoriesTable
          columns={columns}
          data={tableData}
          filters={filters}
          total={total}
          range={range}
          onPaginate={onPaginate}
          onPageSizeChange={onPageSizeChange}
          isPageLoading={isPageLoading}
          isFetching={isFetching}
        />
      </div>
    </div>
  );
};
